import { Component, Inject, OnInit } from '@angular/core';
import { UtilsService } from 'core/utils/utils.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { PaymentDetailsService } from '../services/payment-details.service';
import { QuoteToolsService } from '../services/quote-tools.service';
import { Product } from '../entities/products.class';

@Component({
  selector: 'app-custom-tool',
  templateUrl: './custom-tool.component.html',
  styleUrls: ['./custom-tool.component.scss'],
  standalone: false
})
export class CustomToolComponent implements OnInit {
  productInfo: any;
  appStrings: AppLocalization;
  isMobile: boolean;
  toolForm: UntypedFormGroup;
  mobileCountryList: { value: number, label: string }[] = [];
  templateValues = {};
  countryList: any;
  result = [];
  currencySymbol: any;
  weightSymbol: string;

  constructor(
    public dialogRef: MatDialogRef<CustomToolComponent>,
    private appInfoService: AppInfoService,
    private fb: UntypedFormBuilder,
    private paymentDetailsService: PaymentDetailsService,
    private quoteService: QuoteToolsService,
    private utilsService: UtilsService,
    private deviceService: DeviceDetectorService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.productInfo = data.productInfo;
  }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.isMobile = this.deviceService.isMobile();
    this.currencySymbol = this.appInfoService.currencySymbol;
    this.weightSymbol = this.appInfoService.weightSymbol;
    this.toolForm = this.fb.group({
      partNumber: [{ value: this.productInfo.productNumber, disabled: true }],
      listPrice: [
        this.productInfo.listPrice ? Number(this.productInfo.listPrice.toFixed(2)) : Number(0.01),
        [Validators.required, Validators.pattern(/^\d{1,8}(\.\d{1,2})?$/), Validators.min(0.01)]],
      description: [
        this.productInfo.description,
        [Validators.required, Validators.maxLength(30), Validators.pattern(/.*\S.*/)]],
      unitNetPrice: [
        this.productInfo.netPrice ? Number(this.productInfo.netPrice.toFixed(2)) : Number(0.01),
        [Validators.required, Validators.pattern(/^\d{1,8}(\.\d{1,2})?$/), Validators.min(0.01)]],
      countryOfOrigin: this.productInfo.countryId,
      weight: [
        this.productInfo.weight ? Number(this.productInfo.weight.toFixed(2)) : Number(0.01),
        [Validators.required, Validators.pattern(/^\d{1,8}(\.\d{1,2})?$/), Validators.min(0.01)]],
    });
    this.paymentDetailsService.getStaticValues((templateValues) => this.updateCountryList(templateValues));
  }

  private updateCountryList(serverValues) {
    this.result = serverValues;
    this.countryList = Object.keys(serverValues.CountryCode)
      .map(keyAsString => ({
        key: Number(keyAsString),
        value: serverValues.CountryCode[keyAsString]
      }));
    this.mobileCountryList = this.utilsService.mapObjectToSelect(this.countryList, 'key', 'value');
  }

  saveInfo(element: Product) {
    const payload = {
      productId: this.productInfo.id,
      description: this.toolForm.controls.description.value || '',
      countryOfOrigin: this.toolForm.controls.countryOfOrigin.value || 0,
      listPrice: Number(this.toolForm.controls.listPrice.value) || Number(0.01),
      netPrice: Number(this.toolForm.controls.unitNetPrice.value) || Number(0.01),
      weight: Number(this.toolForm.controls.weight.value) || Number(0.01),
      isRemoved: false
    };
    this.quoteService.saveCustomToolInfo(payload, element);
    this.close(1);
  }

  /**
   * Returns the index of the pressed button. This should be used by the subscriber function to identify the button
   * @param buttonIndex the index of the pressed button
   */
  close(buttonIndex): void {
    this.dialogRef.close(buttonIndex);
  }

  /**
   * Removes the whitespaces from begin and end of description control
   * @param value - the value of description control
   */
  trimDescriptionControl(value) {
    value = value.trim();
    this.toolForm.controls.description.setValue(value);
  }
}
